import { atom } from "jotai";
import { BoundingRect } from "react-measure";

const pageDimensionsAtom = atom<BoundingRect | null | undefined>(null);

export default pageDimensionsAtom;
